import API, { APIResponse } from '../../../lib/commons/api'
import { WbsItemBasic } from '../../../lib/functions/wbsItem'
import { UserBasic } from '../../../domain/value-object/UserBasicVO'

export interface WbsItemDependencyResponse {
  uuid: string
  projectUuid: string
  fromWbsItemUuid: string
  fromProjectPlanUuid: string
  fromDate: string // "YYYY-MM-DD"
  toWbsItemUuid: string
  toProjectPlanUuid: string
  toDate: string // "YYYY-MM-DD"
  color: string | null
  description: string | null
  lockVersion: number
  fromWbsItem: WbsItemBasic
  toWbsItem: WbsItemBasic
  createdAt: number
  createdBy: UserBasic
  updatedAt: number
  updatedBy: UserBasic
}

interface DependencyDeltaRequest {
  added: {
    uuid: string
    fromWbsItemUuid: string
    toWbsItemUuid: string
    color?: string
    description?: string
  }[]
  edited: {
    uuid: string
    color?: string
    description?: string
  }[]
  deleted: { uuid: string }[]
}

export const getWbsItemDependencies = (): Promise<APIResponse> =>
  API.functional.request(
    'GET',
    '/api/v1/projects/wbs_item_dependencies',
    undefined
  )

export const saveWbsItemDependencies = (
  request: DependencyDeltaRequest
): Promise<APIResponse> =>
  API.functional.request(
    'POST',
    '/api/v1/projects/wbs_item_dependencies/delta/batch',
    request
  )
